import React, { useState } from 'react';
import CardContainer from '../card-container';
import Content from './content';

const CardFront = ({ card, readonly, onClick = () => {} }) => {
  const [showCardActions, setShowCardActions] = useState(false);
  function onHoverStart() {
    setShowCardActions(true);
  }

  function onHoverEnd() {
    setShowCardActions(false);
  }

  return (
    <CardContainer
      initial={{ rotateY: 0 }}
      animate={{ rotateY: 0 }}
      exit={{ rotateY: 90, opacity: 0 }}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
      className="relative"
      style={{ userSelect: 'none' }}
    >
      <Content
        card={card}
        showCardActions={showCardActions}
        readonly={readonly}
        onClick={() => onClick()}
      />
    </CardContainer>
  );
};

export default CardFront;
